import { render, staticRenderFns } from "./FormularioTerapeuta.vue?vue&type=template&id=0bbcda43&scoped=true&"
import script from "./FormularioTerapeuta.vue?vue&type=script&lang=js&"
export * from "./FormularioTerapeuta.vue?vue&type=script&lang=js&"
import style0 from "./FormularioTerapeuta.vue?vue&type=style&index=0&id=0bbcda43&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bbcda43",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VApp,VBtn,VCol,VContainer,VForm,VIcon,VRow,VTextarea})
